import {
  ColumnType,
  NumberFormat,
  FormulaResultType,
  DateFormat,
  TimeFormat,
  getFormattedDateTimeByLocale,
} from '@treelab/panda';
import { getFormattedNumber } from './number';
import { getFormattedCurrency } from './currency';
import { Locale } from '../modules/core/types';

export interface IFormulaOptions {
  type: ColumnType.FORMULA | ColumnType.LOOKUP;
  formula: string;
  errorCode?: string;
  resultType: FormulaResultType;
  numberFormat?: NumberFormat;
  precision?: number;
  currencyFormat?: string;
  dateFormat?: DateFormat;
  timeFormat?: TimeFormat;
  includeTime?: boolean;
  useGMT?: boolean;
}

export const getFormattedJoinedFormula = (
  values: string[],
  typeOptions: IFormulaOptions,
  locale: Locale,
) => getFormattedArrayFormula(values, typeOptions, locale).join(', ');

export const getFormattedArrayFormula = (
  values: string[],
  typeOptions: IFormulaOptions,
  locale: Locale,
) => values.map((formula: string) => getFormattedFormula(formula, typeOptions, locale));

export const getFormattedFormula = (
  value: string,
  typeOptions: IFormulaOptions,
  locale: Locale,
) => {
  const {
    resultType,
    numberFormat = NumberFormat.DECIMAL,
    dateFormat = DateFormat.LOCAL,
    timeFormat = TimeFormat.TWELVE_HOUR,
    includeTime,
    precision = 1,
    currencyFormat = '$',
  } = typeOptions;

  switch (resultType) {
    case FormulaResultType.DATE:
      return getFormattedDateTimeByLocale(value, { dateFormat, timeFormat, includeTime }, locale);
    case FormulaResultType.NUMBER:
      switch (numberFormat) {
        case NumberFormat.CURRENCY:
          return getFormattedCurrency(Number(value), {
            currencyFormat,
            precision,
          });
        default:
          return getFormattedNumber(Number(value), { precision, numberFormat });
      }
    case FormulaResultType.TEXT:
      return value;
  }
};
